<template>
  <v-footer class="footer" padless>
    <v-container class="py-16 px-10">
      <v-row>

        <!-- COLUNA 1 -->
        <v-col cols="12" md="3">
          <div class="brand">
            <div class="logo-icon">
              <img src="@/assets/logoSemFundo.png" alt="Logo" width="52" height="40" />
            </div>
            <h1 class="brand-title">Cargas<span style="color:#16b37c">Zap</span></h1>
          </div>

          <p class="brand-description">
            Sistema completo para gestão de transportadoras.
            Tecnologia que simplifica sua operação.
          </p>
        </v-col>

        <!-- COLUNA 2 -->
        <v-col cols="12" md="3">
          <h4 class="footer-title" >Produto</h4>
          <div class="footer-link" @click="redirecionarSecao('Funcionalidades')">Funcionalidades</div>
          <div class="footer-link" @click="redirecionarSecao('Planos')">Planos</div>
          <div class="footer-link" @click="redirecionarSecao('Chatbot WhatsApp')">Chatbot WhatsApp</div>
          <div class="footer-link" @click="redirecionarSecao('Integracoes')">Integrações</div>
          <div class="footer-link" @click="redirecionarSecao('Atualizacoes')">Atualizações</div>
        </v-col>

        <!-- COLUNA 3 -->
        <v-col cols="12" md="3">
          <h4 class="footer-title">Empresa</h4>
          <div class="footer-link" @click="$router.push({ name: 'sobre' })">Sobre Nós</div>
          <div class="footer-link" @click="$router.push({ name: 'termos' })">Termos de Uso</div>
          <div class="footer-link" @click="$router.push({ name: 'politica' })">Política de Privacidade</div>
        </v-col>

        <!-- COLUNA 4 -->
        <v-col cols="12" md="3">
          <h4 class="footer-title">Contato</h4>

          <div class="contact-item">
            <v-icon small class="contact-icon">mdi-email-outline</v-icon>
            josegabrielbm@outlook.com.br
          </div>

          <div class="contact-item">
            <v-icon small class="contact-icon">mdi-phone-outline</v-icon>
            (62) 99341-0844
          </div>

          <div class="contact-item">
            <v-icon small class="contact-icon">mdi-map-marker-outline</v-icon>
            Goias, GO - Brasil
          </div>
        </v-col>

      </v-row>

      <!-- LINHA DIVISÓRIA -->
      <div class="footer-divider"></div>

      <!-- PARTE INFERIOR -->
      <div class="footer-bottom">
        <div class="copyright">
          © 2026 CargasZap. Todos os direitos reservados.
        </div>

        <div class="bottom-links">
          <span @click="$router.push({ name: 'termos' })">Termos</span>
          <span @click="$router.push({ name: 'politica' })">Privacidade</span>
        </div>
      </div>

    </v-container>
  </v-footer>
</template>

<script>
export default {
  name: "FooterBar",

  methods: {
    redirecionarSecao(secao) {
      const id = secao.toLowerCase().replace(/\s+/g, '-');
      const elemento = document.getElementById(id);
      if (elemento) {
        elemento.scrollIntoView({ behavior: 'smooth' });
      }
    }
  }
};
</script>

<style scoped>
.footer {
  background: #0b1624;
  font-family: "Inter", sans-serif;
  color: #9fb3c8;
}

/* LOGO */
.brand {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-bottom: 18px;
}

.logo-icon {
  width: 34px;
  height: 34px;
  border-radius: 8px;
  background: #ffffff;
  display: flex;
  align-items: center;
  justify-content: center;
}

.brand-title {
  color: #ffffff;
  font-weight: 600;
  font-size: 16px;
}

.brand-description {
  font-size: 14px;
  line-height: 1.7;
  max-width: 260px;
}

/* TITULOS */
.footer-title {
  color: #ffffff;
  font-size: 15px;
  font-weight: 600;
  margin-bottom: 18px;
}

/* LINKS */
.footer-link {
  margin-bottom: 12px;
  font-size: 14px;
  cursor: pointer;
  transition: 0.2s;
}

.footer-link:hover {
  color: #ffffff;
}

/* CONTATO */
.contact-item {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-bottom: 14px;
  font-size: 14px;
}

.contact-icon {
  color: #22c58b;
}

/* DIVIDER */
.footer-divider {
  height: 1px;
  background: rgba(255, 255, 255, 0.06);
  margin: 50px 0 30px 0;
}

/* BOTTOM */
.footer-bottom {
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: 13px;
}

.bottom-links span {
  margin-left: 25px;
  cursor: pointer;
  transition: 0.2s;
}

.bottom-links span:hover {
  color: #ffffff;
}
</style>